export const CREATE_REELS_REQUEST="CREATE_REELS_REQUEST"
export const CREATE_REELS_SUCCESS="CREATE_REELS_SUCCESS"
export const CREATE_REELS_FAILUER="CREATE_REELS_FAILURE"

export const GET_ALL_REELS_REQUEST="GET_ALL_REELS_REQUEST"
export const GET_ALL_REELS_SUCCESS="GET_ALL_REELS_SUCCESS"
export const GET_ALL_REELS_FAILUER="GET_ALL_REELS_FAILURE"

export const LIKE_REELS_REQUEST="LIKE_REELS_REQUEST"
export const LIKE_REELS_SUCCESS="LIKE_REELS_SUCCESS"
export const LIKE_REELS_FAILUER="LIKE_REELS_FAILURE"

export const SAVE_REELS_REQUEST="SAVE_REELS_REQUEST"
export const SAVE_REELS_SUCCESS="SAVE_REELS_SUCCESS"
export const SAVE_REELS_FAILUER="SAVE_REELS_FAILURE"

export const GET_USERS_REEL_REQUEST="GET_USERS_REEL_REQUEST"
export const GET_USERS_REEL_SUCCESS="GET_USERS_REEL_SUCCESS"
export const GET_USERS_REEL_FAILUER="GET_USERS_REEL_FAILURE"

